(function () {
  var canvasSelector = '.nt_fk_canvas';

  function normalizeBgUrl(value) {
    if (!value) return '';
    var first = String(value).split(',')[0].trim().split(/\s+/)[0];
    if (first.indexOf('//') === 0) return window.location.protocol + first;
    return first;
  }

  function hydrateBackgrounds(root) {
    (root || document).querySelectorAll('.nt_bg_lz[data-bgset], .pr_lazy_img[data-bgset]').forEach(function (node) {
      if (node.style.backgroundImage && node.style.backgroundImage !== 'none') return;
      var url = normalizeBgUrl(node.getAttribute('data-bgset'));
      if (url) node.style.backgroundImage = 'url("' + url.replace(/"/g, '%22') + '")';
    });
  }

  function closeCanvas() {
    var hasOpenCanvas = document.body.classList.contains('yiume-canvas-open') || document.querySelector('#nt_menu_canvas.act_opened, #nt_search_canvas.act_opened, #nt_login_canvas.act_opened');
    if (!hasOpenCanvas) return;
    document.documentElement.classList.remove('hside_opened');
    document.body.classList.remove('pside_opened');
    document.body.classList.remove('yiume-canvas-open');
    document.querySelectorAll(canvasSelector + '.act_opened').forEach(function (panel) {
      panel.classList.remove('act_opened');
      panel.classList.add('dn');
      panel.setAttribute('aria-hidden', 'true');
    });
  }

  function openCanvas(id) {
    var panel = document.querySelector(id);
    if (!panel) return false;
    closeCanvas();
    panel.classList.remove('dn');
    panel.classList.add('act_opened');
    panel.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('hside_opened');
    document.body.classList.add('pside_opened');
    document.body.classList.add('yiume-canvas-open');
    hydrateBackgrounds(panel);
    var focusTarget = panel.querySelector('input, button, a');
    if (focusTarget) window.setTimeout(function () { focusTarget.focus({ preventScroll: true }); }, 40);
    return true;
  }

  function wireVideos(card, active) {
    card.querySelectorAll('.yiume-hover-video').forEach(function (video) {
      if (active) {
        video.muted = true;
        video.play().catch(function () {});
      } else {
        video.pause();
        video.currentTime = 0;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    hydrateBackgrounds(document);
  });

  document.addEventListener('click', function (event) {
    var closer = event.target.closest('[data-yiume-close-canvas], .close_mn_t4');
    if (closer) {
      event.preventDefault();
      closeCanvas();
      return;
    }

    var toggle = event.target.closest('.yiume-submenu-toggle');
    if (toggle) {
      event.preventDefault();
      var item = toggle.closest('.menu-item-has-children');
      if (item) item.classList.toggle('is-open');
      return;
    }

    var opener = event.target.closest('.push_side[data-id]');
    if (opener) {
      var target = opener.getAttribute('data-id');
      if (target && target !== '#nt_cart_canvas' && openCanvas(target)) {
        event.preventDefault();
      }
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeCanvas();
  });

  document.addEventListener('mouseenter', function (event) {
    var card = event.target.closest && event.target.closest('.nt_pr');
    if (card) wireVideos(card, true);
  }, true);

  document.addEventListener('mouseleave', function (event) {
    var card = event.target.closest && event.target.closest('.nt_pr');
    if (card) wireVideos(card, false);
  }, true);

  document.addEventListener('focusin', function (event) {
    var card = event.target.closest && event.target.closest('.nt_pr');
    if (card) wireVideos(card, true);
  });

  document.addEventListener('focusout', function (event) {
    var card = event.target.closest && event.target.closest('.nt_pr');
    if (card && !card.contains(event.relatedTarget)) wireVideos(card, false);
  });
})();

/* natureechos-newsletter-email-only-asset-v7-success-popup-challenge-return */
(function () {
  var pendingKey = 'natureechosNewsletterPendingAt';
  var pendingTtl = 10 * 60 * 1000;
  var successTimer;

  function getNewsletterForm() {
    return document.getElementById('HomepageNewsletterForm');
  }

  function makeNewsletterEmailOnly() {
    var form = getNewsletterForm();
    if (!form) return;

    var nameInput = form.querySelector('input[name="contact[first_name]"]');
    if (nameInput) {
      nameInput.required = false;
      nameInput.disabled = true;
      nameInput.removeAttribute('required');
      nameInput.removeAttribute('name');

      var nameColumn = nameInput.closest('.col_name');
      if (nameColumn && nameColumn.parentNode) {
        nameColumn.parentNode.removeChild(nameColumn);
      }
    }

    form.classList.add('natureechos-newsletter-email-only-ready');
  }

  function hasHomepageSuccessParam() {
    var params;

    try {
      params = new URLSearchParams(window.location.search);
    } catch (error) {
      return false;
    }

    return params.get('customer_posted') === 'true' && params.get('newsletter') === 'homepage';
  }

  function rememberPendingSubmission() {
    try {
      window.sessionStorage.setItem(pendingKey, String(Date.now()));
    } catch (error) {}
  }

  function clearPendingSubmission() {
    try {
      window.sessionStorage.removeItem(pendingKey);
    } catch (error) {}
  }

  function hasFreshPendingSubmission() {
    var pendingAt;

    try {
      pendingAt = parseInt(window.sessionStorage.getItem(pendingKey) || '', 10);
    } catch (error) {
      return false;
    }

    if (!pendingAt || Number.isNaN(pendingAt)) return false;

    if (Date.now() - pendingAt > pendingTtl) {
      clearPendingSubmission();
      return false;
    }

    return true;
  }

  function cleanHomepageSuccessParams() {
    if (!window.history || !window.history.replaceState) return;

    try {
      var url = new URL(window.location.href);
      var hadSuccess = url.searchParams.has('customer_posted') || url.searchParams.has('newsletter');
      url.searchParams.delete('customer_posted');
      url.searchParams.delete('newsletter');

      if (hadSuccess) {
        window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
      }
    } catch (error) {}
  }

  function hideSuccessPopup(form) {
    if (!form) return;

    var popup = form.querySelector('[data-newsletter-success-popup]');
    if (!popup) return;

    window.clearTimeout(successTimer);
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    window.setTimeout(function () {
      if (!popup.classList.contains('is-visible')) {
        popup.hidden = true;
      }
    }, 280);
  }

  function resetSubmitState(form) {
    if (!form) return;

    var button = form.querySelector('button[type="submit"]');
    var label = button && button.querySelector('span');

    form.classList.remove('is-submitting');

    if (button) {
      button.removeAttribute('aria-busy');
    }

    if (label && label.dataset.originalText) {
      label.textContent = label.dataset.originalText;
      delete label.dataset.originalText;
    }
  }

  function showSuccessPopup(form) {
    if (!form) return;

    var popup = form.querySelector('[data-newsletter-success-popup]');
    if (!popup) return;

    resetSubmitState(form);
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');

    window.requestAnimationFrame(function () {
      popup.classList.add('is-visible');
    });

    window.clearTimeout(successTimer);
    successTimer = window.setTimeout(function () {
      hideSuccessPopup(form);
    }, 5600);

    clearPendingSubmission();
    window.setTimeout(cleanHomepageSuccessParams, 500);
  }

  function shouldShowSuccess(form) {
    if (!form) return false;

    if (form.querySelector('.newsletter-message--error')) return false;

    return hasHomepageSuccessParam() || !!form.querySelector('.newsletter-message--success') || hasFreshPendingSubmission();
  }

  function initNewsletterExperience() {
    makeNewsletterEmailOnly();

    var form = getNewsletterForm();
    if (!form || form.dataset.newsletterExperienceReady === 'true') return;

    form.dataset.newsletterExperienceReady = 'true';

    form.addEventListener('submit', function () {
      var button = form.querySelector('button[type="submit"]');
      var label = button && button.querySelector('span');
      var loading = form.querySelector('[data-newsletter-loading]');

      rememberPendingSubmission();
      form.classList.add('is-submitting');

      if (button) {
        button.setAttribute('aria-busy', 'true');
      }

      if (label && loading && loading.textContent.trim()) {
        label.dataset.originalText = label.textContent;
        label.textContent = loading.textContent.trim();
      }
    });

    var closeButton = form.querySelector('[data-newsletter-success-close]');
    if (closeButton) {
      closeButton.addEventListener('click', function () {
        hideSuccessPopup(form);
      });
    }

    if (shouldShowSuccess(form)) {
      window.setTimeout(function () {
        showSuccessPopup(form);
      }, 260);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewsletterExperience);
  } else {
    initNewsletterExperience();
  }

  window.addEventListener('pageshow', function () {
    var form = getNewsletterForm();
    resetSubmitState(form);
    initNewsletterExperience();
  });
})();
